// File: src/pages/Login.js

// --- 1. ИМПОРТЫ ---
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
// Импортируем хук useAuth для доступа к функции login.
import { useAuth } from '../context/AuthContext';
// Импортируем стили для этой страницы.
import './Login.css';

// --- 2. КОМПОНЕНТ СТРАНИЦЫ ВХОДА ---
const Login = () => {
    // --- 3. СОСТОЯНИЕ КОМПОНЕНТА ---
    // Получаем функцию login из глобального контекста аутентификации.
    const { login } = useAuth();
    const [branding, setBranding] = useState({ company_name: 'Legal OS', project_name: 'Legal OS', instance_name: 'mlg' });

    useEffect(() => {
        fetch('/api/v1/branding').then(r => r.json()).then(data => setBranding(data)).catch(() => {});
    }, []);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    // Состояние для отслеживания процесса входа в систему.
    const [loading, setLoading] = useState(false);

    // --- 4. ОБРАБОТЧИК ОТПРАВКИ ФОРМЫ ---
    const handleSubmit = async (e) => {
        // Предотвращаем стандартное поведение браузера (перезагрузку страницы).
        e.preventDefault();
        setLoading(true); // Включаем индикатор загрузки.
        const loginToast = toast.loading('Signing in...'); // Показываем уведомление.

        try {
            // Вызываем функцию login из контекста, передавая email и пароль.
            await login(email, password);
            toast.success('Login Successful!', { id: loginToast });
            // Навигация на дашборд произойдет автоматически в App.js,
            // так как он отслеживает изменение состояния аутентификации.

        } catch (err) {
            // В случае ошибки показываем пользователю сообщение.
            const errorMessage = err.message || 'Login failed. Please check your credentials.';
            toast.error(errorMessage, { id: loginToast });
        } finally {
            // Вне зависимости от результата, выключаем индикатор загрузки.
            setLoading(false);
        }
    };

    // Tenant-aware skin. Fitenko gets the editorial/serif look that mirrors
    // fitenkolaw.com/documents; everyone else keeps the original MLG card.
    const isFitenko = branding.instance_name === 'fitenko';
    const heading = isFitenko ? 'Secure Client Portal' : `Welcome to ${branding.company_name || 'Legal OS'}`;
    const subtitle = isFitenko
        ? 'Sign in to access your immigration case files and case management tools.'
        : 'Professional Legal Management System';

    // --- 5. JSX-РАЗМЕТКА ---
    return (
        <div className={`login-page-background${isFitenko ? ' login--fitenko' : ''}`}>
            <div className="login-card">
                <div className="logo-container" aria-hidden="true">
                    {isFitenko ? (
                        <svg className="logo-lock" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                        </svg>
                    ) : (
                        <span className="logo-text">{branding.instance_name?.toUpperCase() || 'OS'}</span>
                    )}
                </div>
                <h2 className="welcome-text">{heading}</h2>
                <p className="subtitle-text">{subtitle}</p>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            id="email" type="email" value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required disabled={loading} placeholder="Enter your email"
                            autoComplete="email"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password" type="password" value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required disabled={loading} placeholder="Enter your password"
                            autoComplete="current-password"
                        />
                    </div>
                    <button type="submit" className="signin-button" disabled={loading}>
                        {loading ? 'Signing In…' : (isFitenko ? 'Sign In to Continue' : 'Sign In')}
                    </button>
                </form>
            </div>
        </div>
    );
};

// --- 6. ЭКСПОРТ ---
export default Login;